import { Input } from '@chakra-ui/react'
import DatePicker from 'react-datepicker'

const UncontrolledDatePicker = ({ value, onChange, disabled, maxDate = null }) => {
  const selectedValue = value ? new Date(value) : undefined
  return (
    <Input
      as={DatePicker}
      maxDate={maxDate}
      dateFormat={'dd-MMM-yyyy'}
      showYearDropdown
      showMonthDropdown
      yearDropdownItemNumber={15}
      scrollableYearDropdown
      selected={selectedValue}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export default UncontrolledDatePicker
